/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Rule_Prize_TitleInputs */

const en_event_rule_prize_title = /** @type {(inputs: Event_Rule_Prize_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### 🌸 Event Schedule (UTC+8):  
- Focus Period: 11/3 08:00 – 12/2 08:00  
- Claim Period: 11/3 08:00 – 12/9 08:00

⚠️ Rewards not claimed by the end of the claim period will be forfeited and cannot be reissued or refunded.

### 🎁 Eligibility
- Basic Pass: Open to all users.
- Plus Pass: Requires an active Plus subscription (including trial).

### 🏞️ About the Land Style
- A Land Style changes how your Forest land looks.
- You can switch Land Styles anytime from the “Settings” page.
- The Land Style earned from this event is permanently unlocked and remains available after the event ends.

### 💡 Rules & Details
- Subscribing to Plus only unlocks eligibility; rewards must still be earned by completing tasks.
- Plus rewards can only be unlocked while your Plus subscription is active. Tasks completed after your subscription expires will be ineligible for claiming.
*Example: If your Plus expires on 9/1, rewards for tasks completed on or before 9/1 can be claimed. Tasks completed on 9/2 will be ineligible as the account is no longer Plus.*
- We are not liable for progress loss due to server maintenance, device issues, or network instability. Activity periods will not be extended.
- Please claim all rewards within the claim period; no reissues. Cheating is strictly prohibited. Forest reserves the right to final interpretation and modification.`)
};

const ar_event_rule_prize_title = /** @type {(inputs: Event_Rule_Prize_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### 🌸 جدول الفعالية (UTC+8):  
- فترة التركيز: 3/11 08:00 – 2/12 08:00  
- فترة الاستلام: 3/11 08:00 – 9/12 08:00

⚠️ **الجوائز التي لم يتم استلامها بحلول نهاية فترة الاستلام سيتم مصادرتها ولا يمكن إعادة إصدارها أو استرداد قيمتها.**

### 🎁 الأهلية
- **البطاقة الأساسية:** متاحة لجميع المستخدمين.
- **بطاقة Plus:** تتطلب اشتراك Plus نشطًا (بما في ذلك الفترة التجريبية).

### 🏞️ حول نمط الأرض
- يغيّر نمط الأرض مظهر الأرض في Forest.
- يمكنك تغيير نمط الأرض في أي وقت من صفحة "الإعدادات".
- نمط الأرض الذي تحصل عليه من هذه الفعالية يُفتح بشكل دائم ويظل متاحًا بعد انتهاء الفعالية.

### 💡 القواعد والتفاصيل
- الاشتراك في Plus يفتح فقط الأهلية؛ ولا يزال يتعين كسب الجوائز من خلال إكمال المهام خلال فترة التراكم.
- لا يمكن فتح جوائز Plus إلا أثناء نشاط اشتراك Plus الخاص بك. المهام المكتملة بعد انتهاء صلاحية اشتراكك ستكون غير مؤهلة للمطالبة بها.
*مثال: إذا انتهى اشتراك Plus الخاص بك في 1/9، يمكن المطالبة بالجوائز مقابل المهام المكتملة في 1/9 أو قبله. المهام المكتملة في 2/9 ستكون غير مؤهلة.*
- نحن غير مسؤولين عن فقدان التقدم بسبب صيانة الخادم أو مشاكل الجهاز أو عدم استقرار الشبكة. لن يتم تمديد فترات الفعالية.
- يرجى استلام جميع الجوائز خلال فترة الاستلام. الغش محظور تمامًا. تحتفظ Forest بالحق في التفسير النهائي والتعديل.`)
};

const de_event_rule_prize_title = /** @type {(inputs: Event_Rule_Prize_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### 🌸 Veranstaltungszeitplan (UTC+8):  
- Fokus-Zeitraum: 03.11. 08:00 – 02.12. 08:00  
- Abhol-Zeitraum: 03.11. 08:00 – 09.12. 08:00

⚠️ **Belohnungen, die nicht bis zum Ende des Zeitraums für Belohnungserhalt eingefordert werden, verfallen und können nicht erneut ausgestellt oder erstattet werden.**

### 🎁 Teilnahmeberechtigung
- **Basis-Pass:** Offen für alle Nutzer.
- **Plus-Pass:** Erfordert ein aktives Plus-Abonnement (einschließlich Testversion).

### 🏞️ Hinweise zum Land-Stil
- Ein Land-Stil verändert das Aussehen des Landes in Forest.
- Sie können den Land-Stil jederzeit auf der Seite „Einstellungen“ wechseln.
- Der in dieser Veranstaltung erhaltene Land-Stil wird dauerhaft freigeschaltet und bleibt auch nach Ende der Veranstaltung verfügbar.

### 💡 Regeln & Details
- Das Abonnieren von Plus schaltet lediglich die Teilnahmeberechtigung frei; Belohnungen müssen dennoch durch das Abschließen von Aufgaben innerhalb des Akkumulationszeitraums verdient werden.
- Plus-Belohnungen können nur freigeschaltet werden, während Ihr Plus-Abonnement aktiv ist. Aufgaben, die nach Ablauf Ihres Abonnements abgeschlossen werden, sind nicht für den Erhalt berechtigt.
*Beispiel: Wenn Ihr Plus am 01.09. abläuft, können Belohnungen für Aufgaben, die am oder vor dem 01.09. abgeschlossen wurden, eingefordert werden. Aufgaben, die am 02.09. abgeschlossen werden, sind nicht berechtigt.*
- Wir haften nicht für Fortschrittsverluste aufgrund von Serverwartungen, Geräteproblemen oder Netzwerkinstabilität. Die Aktivitätszeiträume werden nicht verlängert.
- Bitte fordern Sie alle Belohnungen innerhalb des Zeitraums für Belohnungserhalt ein. Betrug ist strengstens untersagt. Forest behält sich das Recht auf endgültige Interpretation und Änderung vor.`)
};

const es_event_rule_prize_title = /** @type {(inputs: Event_Rule_Prize_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### 🌸 Duración del evento (UTC+8)
- Período de concentración: 03/11 08:00 – 02/12 08:00  
- Período de canje: 03/11 08:00 – 09/12 08:00

⚠️ **Las recompensas que no se reclamen antes de que finalice el periodo de obtención se perderán y no podrán ser reemitidas ni reembolsadas.**

### 🎁 Requisitos
- **Pase básico:** Abierto a todos los usuarios.
- **Pase Plus:** Requiere una suscripción Plus activa (incluido el periodo de prueba).

### 🏞️ Acerca del Estilo de terreno
- El Estilo de terreno cambia la apariencia del terreno en Forest.
- Puede cambiar el Estilo de terreno en cualquier momento desde la página "Ajustes".
- El Estilo de terreno obtenido en este evento se desbloquea de forma permanente y seguirá disponible después de que finalice el evento.

### 💡 Reglas y detalles
- Suscribirse a Plus solo desbloquea la elegibilidad; las recompensas deben ganarse completando tareas durante el periodo de acumulación.
- Las recompensas Plus solo pueden desbloquearse mientras su suscripción Plus esté activa. Las tareas completadas después de que expire su suscripción no serán elegibles para ser reclamadas.
*Ejemplo: Si su Plus vence el 1/9, se pueden reclamar las recompensas por las tareas completadas el 1/9 o antes. Las tareas completadas el 2/9 no serán elegibles.*
- No nos hacemos responsables de la pérdida de progreso debido al mantenimiento del servidor, problemas con el dispositivo o inestabilidad de la red. No se extenderán los periodos de actividad.
- Reclame todas las recompensas dentro del periodo de obtención. Las trampas están estrictamente prohibidas. Forest se reserva el derecho de interpretación final y modificación.`)
};

const fr_event_rule_prize_title = /** @type {(inputs: Event_Rule_Prize_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### 🌸 Calendrier de l'événement (UTC+8) :  
- Période de concentration : 03/11 08:00 – 02/12 08:00  
- Période de récupération : 03/11 08:00 – 09/12 08:00

⚠️ **Les récompenses non récupérées avant la fin de la période de récupération seront perdues et ne pourront être réémises ou remboursées.**

### 🎁 Éligibilité
- **Passe basique :** Ouvert à tous les utilisateurs.
- **Passe Plus :** Nécessite un abonnement Plus actif (période d'essai incluse).

### 🏞️ À propos du Style de sol
- Le Style de sol change l'apparence du sol dans Forest.
- Vous pouvez changer de Style de sol à tout moment depuis la page « Paramètres ».
- Le Style de sol obtenu lors de cet événement est débloqué de façon permanente et reste disponible après la fin de l'événement.

### 💡 Règles et Détails
- S'abonner à Plus ne fait que débloquer l'éligibilité ; les récompenses doivent toujours être gagnées en accomplissant des tâches pendant la période d'accumulation.
- Les récompenses Plus ne peuvent être débloquées que si votre abonnement Plus est actif. Les tâches terminées après l'expiration de votre abonnement ne seront pas éligibles pour la récupération.
*Exemple : Si votre abonnement Plus expire le 01/09, les récompenses pour les tâches accomplies le ou avant le 01/09 peuvent être récupérées. Les tâches terminées le 02/09 seront inéligibles.*
- Nous ne sommes pas responsables de la perte de progression due à la maintenance des serveurs, à des problèmes d'appareil ou à l'instabilité du réseau. La durée de l'activité ne sera pas prolongée.
- Veuillez récupérer toutes les récompenses pendant la période de récupération. La triche est strictement interdite. Forest se réserve le droit d'interprétation finale et de modification.`)
};

const it_event_rule_prize_title = /** @type {(inputs: Event_Rule_Prize_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### 🌸 Programma dell'evento (UTC+8):  
- Periodo di concentrazione: 03/11 08:00 – 02/12 08:00  
- Periodo di riscossione: 03/11 08:00 – 09/12 08:00

⚠️ **I premi non riscossi entro la fine del periodo di riscossione andranno persi e non potranno essere riemessi o rimborsati.**

### 🎁 Idoneità
- **Pass base:** Aperto a tutti gli utenti.
- **Pass Plus:** Richiede un abbonamento Plus attivo (incluso il periodo di prova).

### 🏞️ Informazioni sullo Stile del terreno
- Lo Stile del terreno cambia l'aspetto del terreno in Forest.
- Puoi cambiare lo Stile del terreno in qualsiasi momento dalla pagina "Impostazioni".
- Lo Stile del terreno ottenuto in questo evento è sbloccato in modo permanente e rimane disponibile anche dopo la fine dell'evento.

### 💡 Regole e dettagli
- L'abbonamento a Plus sblocca solo l'idoneità; i premi devono comunque essere guadagnati completando le attività durante il periodo di accumulo.
- I premi Plus possono essere sbloccati solo mentre l'abbonamento Plus è attivo. Le attività completate dopo la scadenza dell'abbonamento non saranno idonee alla riscossione.
*Esempio: se il tuo Plus scade il 01/09, i premi per le attività completate entro il 01/09 possono essere riscossi. Le attività completate il 02/09 non saranno idonee.*
- Non siamo responsabili per la perdita di progressi dovuta a manutenzione del server, problemi del dispositivo o instabilità della rete. I periodi di attività non verranno estesi.
- Si prega di riscuotere tutti i premi entro il periodo di riscossione. È severamente vietato barare. Forest si riserva il diritto di interpretazione finale e modifica.`)
};

const ja_event_rule_prize_title = /** @type {(inputs: Event_Rule_Prize_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### 🌸 イベント期間 (UTC+8)  
- 集中期間：11/3 08:00 – 12/2 08:00  
- 受け取り期間：11/3 08:00 – 12/9 08:00

⚠️ **受取期間内に受け取られなかった報酬は無効となり、再発行や払い戻しはいたしかねます。**

### 🎁 参加資格
- **ベーシックパス：** すべてのユーザーが参加可能です。
- **Plusパス：** 有効な Plus 購読（試用期間を含む）が必要です。

### 🏞️ ランドスタイルについて
- ランドスタイルを適用すると、Forestの土地の見た目が変わります。
- ランドスタイルは「設定」ページからいつでも変更できます。
- イベントで獲得したランドスタイルは永久解鎖のため、イベント終了後も引き続きご利用いただけます。

### 💡 規則詳細
- Plus への登録は参加資格を解鎖するものであり、報酬を獲得するには集中時間累計期間内にミッションを完了する必要があります。
- Plus報酬は Plus 購読が有効な期間中にのみ解鎖可能です。購読期限が切れた後に達成されたミッションは、報酬受取の対象外となります。
*例：Plus が 9/1 に期限切れとなる場合、9/1 までに達成したミッションの報酬は受け取れますが、9/2 以降に達成したミッションは対象外となります。*
- サーバーメンテナンス、デバイスの不具合、ネットワークの不安定さによる進度の損失について、弊社は一切の責任を負わず、期間の延長も行いません。
- 報酬は必ず報酬受取期間内にお受け取りください。不正行為は固く禁じられています。Forest は最終的な解釈および修正の権利を留保します。`)
};

const ko_event_rule_prize_title = /** @type {(inputs: Event_Rule_Prize_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### 🌸 이벤트 기간 (UTC+8)  
- 집중 기간: 11/3 08:00 – 12/2 08:00   
- 수령 기간: 11/3 08:00 – 12/9 08:00

⚠️ **수령 기간 내에 수령하지 않은 보상은 소멸되며, 재지급이나 환불이 불가능합니다.**

### 🎁 참여 자격
- **기본 패스:** 모든 사용자가 참여할 수 있습니다.
- **Plus 패스:** 활성 상태인 Plus 구독(체험 기간 포함)이 필요합니다.

### 🏞️ 랜드 스타일 안내
- 랜드 스타일을 적용하면 Forest의 땅 모습이 달라집니다.
- 랜드 스타일은 '설정' 페이지에서 언제든지 변경할 수 있습니다.
- 이벤트에서 획득한 랜드 스타일은 영구적으로 잠금 해제되며, 이벤트 종료 후에도 계속 사용할 수 있습니다.

### 💡 규칙 및 상세 정보
- Plus 구독은 보상 수령 자격을 활성화하는 것이며, 보상을 획득하려면 집중 시간 누적 기간 내에 미션을 완료해야 합니다.
- Plus 보상은 Plus 구독이 유효한 동안에만 활성화할 수 있습니다. 구독 만료 후에 완료된 미션은 보상 수령 대상에서 제외됩니다.
*예: Plus 구독이 9/1에 만료되는 경우, 9/1 이전에 달성한 미션 보상은 수령 가능하지만, 9/2 이후에 달성한 미션은 자격이 주어지지 않습니다.*
- 서버 점검, 기기 문제 또는 네트워크 불안정으로 인한 진행 데이터 손실에 대해 책임을 지지 않으며, 이벤트 기간은 연장되지 않습니다.
- 모든 보상은 반드시 보상 수령 기간 내에 수령해 주세요. 부정행위는 엄격히 금지됩니다. Forest는 최종 해석 및 수정 권한을 보유합니다.`)
};

const pt_br_event_rule_prize_title = /** @type {(inputs: Event_Rule_Prize_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### 🌸 Duração do Evento (UTC+8)
- Período de foco: 03/11 08:00 – 02/12 08:00  
- Período de resgate: 03/11 08:00 – 09/12 08:00

⚠️ **As recompensas não resgatadas até o final do período de resgate serão perdidas e não poderão ser emitidas novamente ou reembolsadas.**

### 🎁 Elegibilidade
- **Passaporte Básico:** Aberto a todos os usuários.
- **Passaporte Plus:** Requer uma assinatura Plus ativa (incluindo período de teste).

### 🏞️ Sobre o Estilo de terreno
- O Estilo de terreno muda a aparência do terreno no Forest.
- Você pode trocar o Estilo de terreno a qualquer momento na página "Configurações".
- O Estilo de terreno obtido neste evento é desbloqueado permanentemente e continua disponível após o término do evento.

### 💡 Regras e Detalhes
- Assinar o Plus apenas desbloqueia a elegibilidade; as recompensas ainda devem ser conquistadas ao completar tarefas durante o período de acúmulo.
- As recompensas Plus só podem ser desbloqueadas enquanto sua assinatura Plus estiver ativa. Tarefas concluídas após a expiração de sua assinatura não serão elegíveis para resgate.
*Exemplo: Se o seu Plus expirar em 01/09, as recompensas por tarefas concluídas em ou antes de 01/09 podem ser resgatadas. Tarefas concluídas em 02/09 serão inelegíveis.*
- Não nos responsabilizamos por perda de progresso devido à manutenção do servidor, problemas no dispositivo ou instabilidade da rede. Os períodos de atividade não serão estendidos.
- Resgate todas as recompensas dentro do período de resgate. É estritamente proibido trapacear. Forest reserva-se o direito de interpretação final e modificação.`)
};

const ru_event_rule_prize_title = /** @type {(inputs: Event_Rule_Prize_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### 🌸 Время проведения мероприятия (UTC+8)
- Период концентрации: 03.11 08:00 – 02.12 08:00  
- Период получения: 03.11 08:00 – 09.12 08:00

⚠️ **Награды, не полученные до окончания периода получения, будут аннулированы и не подлежат повторной выдаче или возврату.**

### 🎁 Условия участия
- **Базовый пропуск:** Доступен для всех пользователей.
- **Plus-пропуск:** Требуется активная подписка Plus (включая пробный период).

### 🏞️ О Стиле земли
- Стиль земли меняет внешний вид земли в Forest.
- Менять Стиль земли можно в любое время на странице «Настройки».
- Стиль земли, полученный в этом мероприятии, разблокируется навсегда и останется доступным после его окончания.

### 💡 Правила и подробности
- Подписка на Plus только открывает доступ к участию; награды необходимо заработать, выполняя задания в период накопления.
- Plus-награды могут быть разблокированы только во время действия подписки Plus. Задания, выполненные после истечения срока действия подписки, не будут учитываться при получении наград.
*Пример: если срок действия вашей подписки Plus истекает 01.09, вы можете получить награды за задания, выполненные не позднее 01.09. Задания, выполненные 02.09, не будут иметь права на получение Plus-наград.*
- Мы не несем ответственности за потерю прогресса из-за технического обслуживания серверов, проблем с устройством или нестабильности сети. Периоды активности не продлеваются.
- Пожалуйста, получите все награды в течение периода получения. Мошенничество строго запрещено. Forest оставляет за собой право на окончательное толкование и изменение правил.`)
};

const th_event_rule_prize_title = /** @type {(inputs: Event_Rule_Prize_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### 🌸 เวลากิจกรรม (UTC+8)
- ช่วงเวลาโฟกัส: 3/11 08:00 – 2/12 08:00  
- ช่วงเวลารับรางวัล: 3/11 08:00 – 9/12 08:00

⚠️ **รางวัลที่ไม่ได้รับภายในสิ้นสุดช่วงเวลารับรางวัลจะถือเป็นโมฆะ และไม่สามารถออกให้ใหม่หรือคืนเงินได้**

### 🎁 สิทธิ์การเข้าร่วม
- **บัตรผ่านพื้นฐาน:** เปิดสำหรับผู้ใช้ทุกคน
- **บัตรผ่าน Plus:** ต้องมีการสมัครสมาชิก Plus ที่ใช้งานอยู่ (รวมถึงช่วงทดลองใช้)

### 🏞️ เกี่ยวกับสไตล์พื้นดิน
- สไตล์พื้นดินจะเปลี่ยนรูปลักษณ์ของพื้นดินใน Forest
- คุณสามารถเปลี่ยนสไตล์พื้นดินได้ตลอดเวลาในหน้า "การตั้งค่า"
- สไตล์พื้นดินที่ได้รับจากกิจกรรมนี้จะปลดล็อกอย่างถาวร และยังสามารถใช้งานได้หลังจากกิจกรรมสิ้นสุด

### 💡 กฎและรายละเอียด
- การสมัครสมาชิก Plus เป็นเพียงการปลดล็อกสิทธิ์เท่านั้น รางวัลจะต้องได้รับจากการทำภารกิจให้สำเร็จในช่วงเวลาสะสม
- รางวัล Plus สามารถปลดล็อกได้ในขณะที่การสมัครสมาชิก Plus ของคุณยังใช้งานอยู่เท่านั้น ภารกิจที่ทำสำเร็จหลังจากสมาชิกหมดอายุจะไม่สามารถรับรางวัลได้
*ตัวอย่าง: หาก Plus ของคุณหมดอายุในวันที่ 1/9 รางวัลสำหรับภารกิจที่ทำสำเร็จภายในวันที่ 1/9 หรือก่อนหน้านั้นจะสามารถรับได้ ภารกิจที่ทำสำเร็จในวันที่ 2/9 จะไม่มีสิทธิ์รับรางวัล Plus*
- เราจะไม่รับผิดชอบต่อความสูญเสียความคืบหน้าอันเนื่องมาจากการบำรุงรักษาเซิร์ฟเวอร์ ปัญหาของอุปกรณ์ หรือความไม่เสถียรของเครือข่าย จะไม่มีการขยายเวลากิจกรรม
- โปรดรับรางวัลทั้งหมดภายในช่วงเวลารับรางวัล ห้ามทำการโกงโดยเด็ดขาด Forest ขอสงวนสิทธิ์ในการตีความขั้นสุดท้ายและการแก้ไขเปลี่ยนแปลง`)
};

const tr_event_rule_prize_title = /** @type {(inputs: Event_Rule_Prize_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### 🌸 Etkinlik Süresi (UTC+8)
- Odaklanma Dönemi: 03.11 08:00 – 02.12 08:00  
- Talep Dönemi: 03.11 08:00 – 09.12 08:00

⚠️ **Ödül talep dönemi sonuna kadar alınmayan ödüller geçersiz sayılır; yeniden verilemez veya iade edilemez.**

### 🎁 Katılım Şartları
- **Standart Bilet:** Tüm kullanıcılara açıktır.
- **Plus Bilet:** Aktif bir Plus aboneliği (deneme süresi dahil) gerektirir.

### 🏞️ Arazi Türü Hakkında
- Arazi Türü, Forest'taki arazinin görünümünü değiştirir.
- Arazi Türünü istediğiniz zaman "Ayarlar" sayfasından değiştirebilirsiniz.
- Bu etkinlikte kazanılan Arazi Türü kalıcı olarak açılır ve etkinlik sona erdikten sonra da kullanılabilir.

### 💡 Kurallar ve Detaylar
- Plus abonesi olmak yalnızca katılım hakkını açar; ödüllerin biriktirme dönemi içinde görevler tamamlanarak kazanılması gerekir.
- Plus ödülleri yalnızca Plus aboneliğiniz aktifken açılabilir. Aboneliğiniz sona erdikten sonra tamamlanan görevler ödül talebi için geçersiz sayılacaktır.
*Örnek: Plus aboneliğiniz 01.09 tarihinde sona eriyorsa, 01.09 tarihinde veya öncesinde tamamlanan görevlerin ödülleri alınabilir. 02.09 tarihinde tamamlanan görevler için hak iddia edilemez.*
- Sunucu bakımı, cihaz sorunları veya ağ kararsızlığı nedeniyle oluşan ilerleme kayıplarından sorumlu değiliz. Etkinlik süreleri uzatılmayacaktır.
- Lütfen tüm ödülleri talep dönemi içinde alın. Hile yapmak kesinlikle yasaktır. Forest, son yorumlama ve değişiklik yapma hakkını saklı tutar.`)
};

const zh_cn_event_rule_prize_title = /** @type {(inputs: Event_Rule_Prize_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### 🌸 活动时间 (UTC+8)  
- 专注时长累积期间：11/3 08:00 – 12/2 08:00  
- 奖励领取期间：11/3 08:00 – 12/9 08:00

⚠️ 逾期未领取奖励视为自动放弃，无法补发或退款。

### 🎁 领取资格
- 基础通行证： 所有用户均可参加。
- Plus 通行证： 需在 Plus 会员 (含试用期) 效期内。

### 🏞️ 土地皮肤使用说明
- 土地皮肤可改变森林土地的外观。
- 可随时在“设置”页面更换土地皮肤。
- 活动中获得的土地皮肤为永久解锁，活动结束后仍可继续使用。

### 💡 规则说明
- 购买 Plus 会员仅解锁领取资格，奖励仍须在活动期间内完成任务方可获得。
- Plus 会员效期内拥有 Plus 奖励领取资格，但若会员到期后才达成的奖励将不具领取资格。
例： 若 Plus 会员于 9/1 到期，在 9/1 之前达成的任务奖励均可领取；但 9/2 才达成的任务则因已非 Plus 会员身份而不具备领取资格。
- 若因服务器维护、设备或网络环境导致进度损失，官方不负补偿责任亦不延长活动时间。
- 奖励请务必在奖励领取期间内领取，逾期不补发。严禁作弊行为，官方保有活动最终解释与修改权。`)
};

const zh_tw_event_rule_prize_title = /** @type {(inputs: Event_Rule_Prize_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### 🌸 活動時間 (UTC+8)  
- 專注累積期間：11/3 08:00 – 12/2 08:00  
- 獎勵領取期間：11/3 08:00 – 12/9 08:00

⚠️ 逾期未領取獎勵視同放棄，恕不補發或退款

### 🎁 領取資格
- 基礎通行證：所有用戶皆可參加。
- Plus 通行證：需在 Plus 訂閱 (含試用期) 效期內。

### 🏞️ 土地造型使用說明
- 土地造型可改變森林土地的外觀。
- 可隨時於「設定」頁面更換土地造型。
- 活動中獲得的土地造型為永久解鎖，活動結束後仍可繼續使用。

### 💡 規則說明
- 訂閱 Plus 僅解鎖領取資格，獎勵仍須於活動期間內完成任務才可獲得。
- Plus 訂閱效期內擁有 Plus 獎勵領取資格，但若到期後才達成的獎勵將不具領取資格。
例：若 Plus 於 9/1 到期，在 9/1 之前達成的任務獎勵都可以領取；但 9/2 才達成的任務則因已非 Plus 而不具備領取資格。
- 若因伺服器維護、設備或網路環境導致進度損失，官方不負補償責任亦不延長活動時間。
- 獎勵務必於期限內領取，逾期不補發。嚴禁作弊行為，官方保有最終活動解釋與修改權。`)
};

/**
* | output |
* | --- |
* | "### 🌸 Event Schedule (UTC+8): - Focus Period: 11/3 08:00 – 12/2 08:00 - Claim Period: 11/3 08:00 – 12/9 08:00 ⚠️ Rewards not claimed by the end of the claim..." |
*
* @param {Event_Rule_Prize_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const event_rule_prize_title = /** @type {((inputs?: Event_Rule_Prize_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Rule_Prize_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_rule_prize_title(inputs)
	if (locale === "ar") return ar_event_rule_prize_title(inputs)
	if (locale === "de") return de_event_rule_prize_title(inputs)
	if (locale === "es") return es_event_rule_prize_title(inputs)
	if (locale === "fr") return fr_event_rule_prize_title(inputs)
	if (locale === "it") return it_event_rule_prize_title(inputs)
	if (locale === "ja") return ja_event_rule_prize_title(inputs)
	if (locale === "ko") return ko_event_rule_prize_title(inputs)
	if (locale === "pt_br") return pt_br_event_rule_prize_title(inputs)
	if (locale === "ru") return ru_event_rule_prize_title(inputs)
	if (locale === "th") return th_event_rule_prize_title(inputs)
	if (locale === "tr") return tr_event_rule_prize_title(inputs)
	if (locale === "zh_cn") return zh_cn_event_rule_prize_title(inputs)
	return zh_tw_event_rule_prize_title(inputs)
});